/** 
 *
 * Ping a URL and return the time taken (latency).
 *
 */
const pingAsync = async (url) => {

    let start = performance.now();

    try {
        let response = await fetch("https://" + url + `/test.dat?cb=${Date.now()}`, {
            method: "GET",
//            mode: "no-cors",
            headers: {
//                Accept: "binary/octet-stream,text/plain",
                Accept: "text/plain",
            },
        });

        await response.text(); // Read response to get the actual time.
  
        let end = performance.now();

        if (response.ok) {
            return end - start;
        }
    } catch (error) {
        // TODO: Write to log.
        // console.log(error.message);
    }

    // Error.
    return 0;
};

/** Test latency by pinging a server multiple times.
 *
 *  target -> URL of server to ping.
 *  testCount -> maximum pings to perform.
 *  testTime -> maximum time (ms) to perform pings.
 *
 *  Returns an array of latencies.
 */
export const testLatencyAsync = async (
    target,
    testCount,
    testTime,
    setResults,
    onDone
) => {
    var latencies = [];
    var stopTime = Date.now() + testTime; // Test stop time in ms.

    // Do the first and throw it away because it may include a DNS lookup.
    await pingAsync(target);

    // console.log(`max time: ${testTime}`);
    // console.log(`max tests: ${testCount}`);

    for (var n = 0; n < testCount && Date.now() < stopTime; ++n) {
        let latency = await pingAsync(target);
        if (latency) {
            // Latency from the ping is a two way timing with processing on the server so adjust it accordingly.
            latency = (latency - 10) / 2;
            if (latency <= 0) latency = 10; // Just in case. This really shouldn't ever happen.
            latencies.push(latency);
            setResults(latency);
        }
    }

    // console.log(`out of here`);

    if (onDone) {
        // Call the done handler.
        onDone();
    }

    return latencies;
};
